export default __webpack_public_path__ + "assets/b588202370f2d4858bfb10031d897da7.svg";